import { IActionContext } from "@msdyn365-commerce/core";
import { callActionOrExecute, DataServiceQuery, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
import { IProductListCount, ProductListCountExtensionClass } from './entities/product-list-count';

export function getProductListCountsInput(productListIds: string[]): IDataServiceRequest {
    const query = new DataServiceQuery("VinhusetProductLists", "VinhusetProductList");

    return query.createDataServiceRequestForOperation('GetProductListCounts',
        true,
        ProductListCountExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IProductListCount' },
        { productListIds: productListIds });
}

export async function getProductListCountsAsync(context: IActionContext, productListIds: string[]): Promise<IProductListCount[]> {
    const request = getProductListCountsInput(productListIds);
    const result = await callActionOrExecute<IProductListCount[]>(request, context);
    return result;
}

export function getCountingListCountsInput(productListIds: string[]): IDataServiceRequest {
    const query = new DataServiceQuery("VinhusetProductLists", "VinhusetProductList");

    return query.createDataServiceRequestForOperation('GetCountingListCounts',
        true,
        ProductListCountExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IProductListCount' },
        { productListIds: productListIds });
}

export async function getCountingListCountsAsync(context: IActionContext, productListIds: string[]): Promise<IProductListCount[]> {
    const request = getCountingListCountsInput(productListIds);
    const result = await callActionOrExecute<IProductListCount[]>(request, context);
    return result;
}
